/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-restricted-syntax */
type Obj = { [key: string]: any }

export function filterObjectValues(obj: Obj) {
  const filteredObject: Obj = {}

  for (const [key, value] of Object.entries(obj)) {
    if (value !== undefined && value !== null && value !== '') {
      filteredObject[key] = value
    }
  }

  return filteredObject
}
